<template>
  <button type="button">
    <b-spinner
      v-if="loading"
      style="width: 15px; height: 15px; border-width: 2px"
    />
    {{ text }}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width="16px"
      height="16px"
    >
      <path
        fill="currentColor"
        d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8 170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8 490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: "SubmitButton",
  props: {
    text: { type: String, required: true },
    loading: { type: Boolean },
  },
};
</script>

<style scoped lang="scss">
button {
  all: unset;
  background-color: var(--theme-color-primary);
  color: var(--theme-color-primary-contrast);
  font-weight: 600;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;

  svg {
    transition: margin-left 0.2s ease-in-out;
    margin-left: 0;
  }

  &:hover {
    background-color: rgba(var(--theme-color-primary-rgb), 0.9);
    svg {
      margin-left: 8px;
    }
  }
}
</style>
